import axios from 'axios';

const API_BASE_DATA_AND_BI_URL = '/api/DataBi';

export function getSettings(data) {
  const url = `${API_BASE_DATA_AND_BI_URL}/iframesSettings`;
  return axios.post(url, data).then((response) => response.data);
}

